import React from "react";
import styled from "styled-components";
import { useLoading } from "./LoadingContext";

const LoadingOverlay = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const LoaderContainer = styled.div`
  text-align: center;
`;

const Spinner = styled.div`
  margin: 10px auto;
  width: 50px;
  height: 50px;
  border: 5px solid red;
  border-top: 5px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  background-color: #e0e0e0;
  height: 5px;
  border-radius: 5px;
  margin-top: 10px;
`;

const ProgressBar = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress}%;
  background-color: red;
  height: 5px;
  border-radius: 5px;
`;

const LoadingBar: React.FC<{ progress?: number }> = ({ progress = 50 }) => {
  const { isLoading } = useLoading();

  return (
    <LoadingOverlay isVisible={isLoading}>
      <LoaderContainer>
        <img src="/wsplogo.png" alt="WSP Logo" width={100} />
        <Spinner />
        <span>Loading...</span>
        <ProgressBarContainer>
          <ProgressBar progress={progress} />
        </ProgressBarContainer>
      </LoaderContainer>
    </LoadingOverlay>
  );
};

export default LoadingBar;
